namespace TabAurous.ECommerce {
    export namespace PickUpService {
        export const baseUrl = 'ECommerce/PickUp';

        export declare function Create(request: Serenity.SaveRequest<PickUpRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PickUpRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PickUpRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetCustomerandProductDetails(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PickUpRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<PickUpRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ECommerce/PickUp/Create",
            Update = "ECommerce/PickUp/Update",
            Delete = "ECommerce/PickUp/Delete",
            Retrieve = "ECommerce/PickUp/Retrieve",
            GetCustomerandProductDetails = "ECommerce/PickUp/GetCustomerandProductDetails",
            List = "ECommerce/PickUp/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'GetCustomerandProductDetails', 
            'List'
        ].forEach(x => {
            (<any>PickUpService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
